import { useMemo } from 'react';
import { useInstanceEvent, useStoreContext } from '../../context/store';
import { get } from 'lodash';
import { useI18n } from '../../utils/i18n';

const QuestionDerivatedView = ({ module, headers = [], answer }) => {
  const derivated = get(module, 'metadata.settings.derivated');
  const score_type = module?.score_type;
  const { context  } = useStoreContext();
  const { showErrors} = context.data;

  const t = useI18n();

  const answers = useInstanceEvent('nav', (instance) => instance.nav.answers);

  const subAnswers = answer?.answers;

  const errors = module.getErrors({ answers });

  const dataSource = useMemo(() => {
    const derivatedAnswer = answers.find(
      (answer) => get(answer, 'module.id') === derivated
    );
    if (!subAnswers.length) {
      const derivatedModuleMotives = derivatedAnswer.module.motives;
      answer.setAnswers(
        derivatedAnswer.motives.map((motive) => {
          const derivatedMotive = derivatedModuleMotives.find(
            (derivatedMotive) => derivatedMotive.id === motive.id
          );
          return {
            module: module,
            motives: [
              {
                ...motive,
                ui_name: derivatedMotive?.ui_name,
                name: derivatedMotive?.name,
              },
            ],
          };
        })
      );
    }
    return [...answer.answers];
  }, [derivated]);

  const columns = useMemo(() => {
    const newColumns = [
      {
        title: '',
        field: 'name',
        render: (row) =>{
          let value = get(row.motives[0],'ui_name',get(row.motives[0],'name'));
          if(get(row.motives[0],'metadata.settings.showInput',false)===true) value = get(row.motives[0],'comment');
          return (<span>{value}</span>)
        },
        key: 'name',
      },
    ];

    headers.forEach((header) => {
      newColumns.push({
        title: header?.caption ?? header?.ui_name ?? header?.name,
        render: (value) => {
          return (
            <div className="preguntaAgrupadaInputStyle">
              <div
                className={
                  score_type
                    ? value.score == header.score
                      ? 'select'
                      : 'sinselect'
                    : get(header, 'id', null) === get(value, 'motives.1.id')
                    ? 'select'
                    : 'sinselect'
                }
                onClick={() => {
                  if (score_type) {
                    value.setScore(header?.score ?? null);
                  } else {
                    const motivoId = get(header, 'id');
                    value.setMotives(
                      [
                        get(value, 'motives.0'),
                        { id: motivoId, comment: null },
                      ],
                      {
                        preventDirty: false,
                      }
                    );
                  }
                }}
              />
            </div>
          );
        },
      });
    });

    return newColumns;
  }, [headers]);

  const isLongTable = columns.length > 10;

  return (
    <div>
      <div className="matrix-table-container">
        <table className="matrix-table">
          <colgroup> </colgroup>
          <thead className={isLongTable ? undefined : 'ant-table-thead'}>
            <tr>
              {columns.map((column, index) => (
                <th
                  className={`matrix-th`}
                  key={`matrix-th-${column.title}-${index}`}
                >
                  {column.title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {dataSource.map((data, index) => (
              <tr
                key={`matrix-row-${index}`}
                className={isLongTable ? ' ' : 'ant-table-row'}
              >
                {columns.map((column) => (
                  <td key={column.key} className={'ant-table-cell'}>
                    {column.render(data)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {showErrors === true && errors?.length ? (
        <div className={'error'}>* {t('errors.complete-question')}</div>
      ) : null}
    </div>
  );
};

export default QuestionDerivatedView;
